const imgHost = process.env.GATSBY_RL_IMG_URL ?? '/static';
const MhImageHost = process.env.GATSBY_MH_IMG_URL ?? '/static';

export const getMHImageUrl = (imgSrc) => `${MhImageHost}/${imgSrc}`;

export const getImageUrl = (imgSrc) => `${imgHost}/${imgSrc}`;
